// Copyright (c) Zammo Inc.
import React from 'react';
import styled from 'styled-components';

import URLInput from './URLInput';

const Container = styled.div`
  background: white;
  padding: 10px 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface Props {
  setURL: (value: string) => void;
  isShowURLInput: boolean;
}
const Header = ({ setURL, isShowURLInput }: Props) => {
  return <Container>{isShowURLInput && <URLInput setURL={setURL} />}</Container>;
};

export default Header;
